import { logError } from "~src/utils/logger";

/**
 * Validates if a URL is a valid image based on its file extension.
 * Supports: jpg, jpeg, png, webp, avif, gif
 * Handles URLs with query parameters by removing them before validation.
 *
 * @param img_url - The image URL to validate
 * @returns true if the URL has a valid image extension, false otherwise
 */
export const isValidImage = (img_url: string | null): boolean => {
  if (!img_url) return false;
  // Remove query parameters and check extension
  const baseUrl = img_url.split('?')[0];
  return /\.(jpg|jpeg|png|webp|avif|gif)$/i.test(baseUrl);
};

/**
 * Validates if a URL is a valid video based on its file extension.
 * Supports: mp4, avi, mov, mkv, webm
 * Handles URLs with query parameters by removing them before validation.
 *
 * @param video_url - The video URL to validate
 * @returns true if the URL has a valid video extension, false otherwise
 */
export const isValidVideo = (video_url: string | null): boolean => {
  if (!video_url || video_url === "N/A") return false;
  try {
    // Remove query parameters and check extension
    const baseUrl = video_url.split('?')[0];
    return /\.(mp4|avi|mov|mkv|webm)$/i.test(baseUrl);
  } catch (e) {
    logError(`Error validating video URL: ${e}`);
    return false;
  }
};
